import { InputfieldTypes } from "../../../../../../enums/InputFieldAttributesEnums";

export const dropDownFields = {
  TON_TXT: "Ton",
  LOAD_TXT: "Load",
  HOUR_TXT: "Hour",
};

export const getEditJobFields = ({
  selectTruckingAfterFieldProps,
  selectTruckingPriceAfterFieldProps,
  selectLandedPriceAfterFieldProps,
  handleTruckingPriceCost,
  selectedTruckingPriceUnit,
  onKeyDownHandler,
  onNumericBlur,
}) => {
  return [
    {
      name: "pickUpAddress",
      type: InputfieldTypes.TEXT,
      label: "Pickup Location",
      disabled: true,
    },
    {
      name: "deleiveryAddress",
      type: InputfieldTypes.TEXT,
      label: "Delivery Location",
      disabled: true,
    },
    {
      name: "milesAndDistance",
      type: InputfieldTypes.TEXT,
      label: "Miles and Distance",
      disabled: true,
    },
    {
      name: "truckType",
      type: InputfieldTypes.TEXT,
      label: "Truck Type",
      disabled: true,
      onKeyDownHandler: onKeyDownHandler,
    },
    {
      name: "materialName",
      type: InputfieldTypes.TEXT,
      label: "Material",
      disabled: true,
      onKeyDownHandler: onKeyDownHandler,
    },
    {
      name: "truckingCost",
      type: InputfieldTypes.TEXT,
      label: "Trucking Cost",
      disabled: false,
      prefix: "$",
      onKeyDownHandler: onKeyDownHandler,
      addonLater: selectTruckingAfterFieldProps,
      onBlur: () => handleTruckingPriceCost(false, 1 / 0.875),
    },
    {
      name: "truckingPrice",
      type: InputfieldTypes.TEXT,
      label: "Trucking Price",
      disabled: false,
      prefix: "$",
      onKeyDownHandler: onKeyDownHandler,
      addonLater: selectTruckingPriceAfterFieldProps,
      onBlur: () => handleTruckingPriceCost(true, 0.875),
    },
    {
      name: "minimumHours",
      type: InputfieldTypes.TEXT,
      label: "Minimum Hours",
      placeholder: "Enter Hours",
      onBlur: onNumericBlur("minimumHours"),
      onKeyDownHandler: onKeyDownHandler,
      disabled: selectedTruckingPriceUnit !== dropDownFields.HOUR_TXT,
    },
  ];
};
